import React, { useState } from "react"
import { Router, Switch, Route } from "react-router-dom"
import Home from "./../pages/Home";
import About from "./../pages/About";
import history from './History';
import TrashContainer from "../pages/TrashContainer";
import { ItemTypes } from "../Types/TrashTypes";

const Switcher = () => {
    const [selectedCity, setSelectedCity] = useState('berlin');
    const [isSound, setIsSound] = useState(false);


    return (
        <Router history={history}>
            <Switch>
                <Route path="/About">
                    <About />
                </Route>
                {Object.keys(ItemTypes[selectedCity]).map((key) => ItemTypes[selectedCity][key]).map((component, index) => <Route path={"/" + component.name.toLowerCase()} key={index}><TrashContainer recycleBins={[{ name: 'Re-sort', type: 'any', description: 'If an item was sorted incorrectly, the item can be removed again by dragging the item here.' }]} type={component.type} key={index} isSound={isSound} /></Route>)}
                <Route path="/">
                    <Home setSelectedCity={setSelectedCity} selectedCity={selectedCity} isSound={isSound} setIsSound={(e) => setIsSound(e)} />
                </Route>
            </Switch>
        </Router>
    )
}

export default Switcher